window.handleModalsAfterQuestionCreate = function() {
  $("#callUsModal").modal('hide');
}